export const categories = [
  'Digital Marketing',
  'Performance Marketing',
  'Meta Ads',
  'Google Ads',
  'SEO',
  'Website Development',
  'App Development',
  'AI',
  'AI Tools',
  'Business Growth',
  'Digital Technology',
];

export const articles = [
  {
    slug: 'marketing-funnel-that-turns-attention-into-action',
    title: 'The practical marketing funnel: turn attention into action',
    excerpt: 'A simple way to connect your message, media, landing page, and follow-up so every click has a next step.',
    category: 'Digital Marketing',
    author: 'Aadit Growth Desk',
    publishedAt: '2026-08-12',
    updatedAt: '2026-08-18',
    readingTime: '7 min read',
    featured: true,
    accent: 'coral',
    relatedSlugs: ['google-ads-budget-planning', 'seo-content-brief'],
    sections: [
      { heading: 'Start with the decision, not the channel', paragraphs: ['Before choosing a platform, name the decision you want a visitor to make. A useful funnel moves from a clear promise to proof, then to one low-friction action.', 'That sequence keeps your campaigns easier to measure and prevents a beautiful landing page from becoming an expensive dead end.'] },
      { heading: 'Build one connected journey', paragraphs: ['Match the language in your ad to the first screen of the landing page. Then make the next action obvious: enquire, book a call, download a guide, or start a trial.', 'Track each step separately. Reach, clicks, qualified enquiries, and closed business answer different questions and should not be collapsed into one vanity metric.'] },
      { heading: 'Use the follow-up as part of the funnel', paragraphs: ['Most prospects need context before they are ready. A short, useful email sequence or remarketing path can answer objections without crowding the original conversion moment.', 'Review the journey every month and remove steps that do not help a real person decide.'] },
    ],
  },
  {
    slug: 'google-ads-budget-planning',
    title: 'Google Ads budget planning for a first profitable campaign',
    excerpt: 'How to set a testing budget, choose a useful conversion event, and decide when a campaign has earned more room.',
    category: 'Google Ads',
    author: 'Mira Shah',
    publishedAt: '2026-08-05',
    updatedAt: '2026-08-05',
    readingTime: '6 min read',
    accent: 'blue',
    relatedSlugs: ['marketing-funnel-that-turns-attention-into-action', 'seo-content-brief'],
    sections: [
      { heading: 'Work backwards from commercial value', paragraphs: ['A starting budget should be connected to the value of a qualified enquiry, not an arbitrary daily number. Estimate how many clicks you need for one useful lead and what a lead is worth to the business.', 'Your first job is learning which search intent produces a conversation. Profitability becomes more reliable after that signal is clear.'] },
      { heading: 'Choose one primary conversion', paragraphs: ['Use a meaningful event such as a completed enquiry, booked consultation, or purchase. Secondary events like page views can be helpful diagnostics, but they should not steer automated bidding.', 'Give the campaign enough time and volume to show a pattern before making large changes.'] },
    ],
  },
  {
    slug: 'seo-content-brief',
    title: 'How to write an SEO content brief people actually use',
    excerpt: 'A content brief should make the writer smarter about the reader, not just hand them a list of keywords.',
    category: 'SEO',
    author: 'Aadit Growth Desk',
    publishedAt: '2026-07-28',
    updatedAt: '2026-08-02',
    readingTime: '8 min read',
    accent: 'green',
    relatedSlugs: ['marketing-funnel-that-turns-attention-into-action', 'ai-tools-for-marketing-teams'],
    sections: [
      { heading: 'Describe the reader in a real moment', paragraphs: ['Start with the question behind the query. What has the reader tried? What makes the decision difficult? A specific situation produces more useful content than a broad demographic label.', 'Add the next action the article should support, such as comparing options, planning a project, or contacting a specialist.'] },
      { heading: 'Give the writer a point of view', paragraphs: ['List the essential questions to answer and the evidence that would make the answer trustworthy. Competitor headings are useful inputs, but they are not a strategy.', 'Include internal links to the pages that continue the reader journey. This is good information architecture and a practical way to connect organic traffic to services.'] },
    ],
  },
  {
    slug: 'ai-tools-for-marketing-teams',
    title: 'A useful AI tool stack for a small marketing team',
    excerpt: 'Where AI can remove repetitive work while strategy, judgment, and customer understanding stay human-led.',
    category: 'AI Tools',
    author: 'Mira Shah',
    publishedAt: '2026-07-14',
    updatedAt: '2026-07-20',
    readingTime: '5 min read',
    accent: 'yellow',
    relatedSlugs: ['seo-content-brief', 'marketing-funnel-that-turns-attention-into-action'],
    sections: [
      { heading: 'Automate the repeatable edges', paragraphs: ['AI is most useful when the task has a clear input, a reviewable output, and a human owner. Meeting notes, first-draft variations, research summaries, and data cleanup are good candidates.', 'Keep customer data and confidential material inside tools with an appropriate privacy model. Convenience is not a reason to skip governance.'] },
      { heading: 'Create a review habit', paragraphs: ['Define what good looks like before the team adopts a tool. Review factual accuracy, brand fit, accessibility, and whether the output genuinely helps the customer.', 'A small, well-understood stack will usually outperform a shelf full of disconnected experiments.'] },
    ],
  },
];